query CommunicationChannels(
  $first: Int
  $after: Cursor
  $orderBy: [CommunicationChannelsOrderBy!]
  $filter: CommunicationChannelFilter
) {
  communicationChannels(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    nodes {
      id
      name
      description
      isMessages
      isReports
      _isAlerts
      _rowTimestamp
      _isUpdatable
      _isDeletable
      _createdDate
    }
  }
}
